// src/directives/disableArrowToggle.js

export default {
  inserted(el, binding) {
    const keysToBlock = binding.value || ['ArrowLeft', 'ArrowRight'];

    el.addEventListener(
      'keydown',
      (e) => {
        if (keysToBlock.includes(e.key)) {
          e.stopImmediatePropagation(); // 拦截 Element UI 内部监听
          e.preventDefault(); // 防止浏览器默认行为
        }
      },
      true // 捕获阶段，确保早于 Element UI 执行
    );
  }
};



// WEBPACK FOOTER //
// ./src/js/directives/disableArrowToggle.js